export default __webpack_public_path__ + "static/ELDP-S3-MD-f9218d15bc00afe76c9ff3b6b634f89f.webp";